import { Component } from '@angular/core';

@Component({
  selector: 'app-lock-correction-dialog',
  templateUrl: 'lock-correction-dialog.component.html',
})
export class LockCorrectionDialogComponent {}
